// extracted by mini-css-extract-plugin
export default {"container":"_39I7y","triangle":"_3X_id","right":"_3d-Th","left":"_1W9KQ","bottom":"_23kSH"};